import {
    captureException as sentryCaptureException,
    captureMessage as sentryCaptureMessage,
    withScope,
} from '@sentry/react';
import { type Contexts } from '@sentry/types';
import { getErrorContext, getErrorFeatureGroup } from '@lingoda/errors';

type Primitive = number | string | boolean | null | undefined;

export const captureError = (error: unknown) => {
    withScope(() => {
        const contexts = getErrorContext(error);
        const featureGroup = getErrorFeatureGroup(error);

        sentryCaptureException(error, {
            level: 'error',
            contexts,
            tags: featureGroup ? { featureGroup } : undefined,
        });
    });
};

export const captureEvent = (event: unknown, context: { tags: Record<string, Primitive> }) => {
    sentryCaptureException(event, {
        level: 'log',
        tags: context.tags,
    });
};

export const captureMessage = (message: string, contexts?: Contexts) => {
    withScope((scope) => {
        scope.setLevel('debug');

        sentryCaptureMessage(message, contexts ? { contexts } : undefined);
    });
};
